import {
  Bookmark,
  ContinueWatchingBookmark,
  EntitlementTitleType,
  HuaweiBookmark,
  TEntitlementProduct,
} from '@modules/simulations/types';

import { FavoritesInsightsResponse } from '@models/Favorites';

import { createAdminApi, createSubscriberApi, getApiBaseUrl } from '../shared/utils';

type ProviderClientDTO = {
  id: string;
  image: string;
  isSubscribed: boolean;
  name: string;
  type: string;
};

export const clientApi = createSubscriberApi(getApiBaseUrl('profile'), { 'x-api-version': '1.0' });
export const profileAdminApi = createAdminApi(getApiBaseUrl('profile'), { 'x-api-version': '1.0' });

export const fetchPurchases = () => clientApi.get<TEntitlementProduct[]>('me/purchases');

export const fetchPurchasedTitles = () =>
  clientApi.get<EntitlementTitleType[]>('me/purchases/titles');

export const fetchRentals = () => clientApi.get<TEntitlementProduct[]>('me/rentals');

export const fetchRentedTitles = () => clientApi.get<EntitlementTitleType[]>('me/rentals/titles');

export const fetchContinueWatching = (profileId?: string) =>
  clientApi.get<ContinueWatchingBookmark[]>('me/bookmarks/continuewatching/titles', { profileId });

export const fetchAllBookmarks = () => clientApi.get<Bookmark[]>('me/bookmarks/references/all');

export const fetchAllHuaweiBookmarks = () =>
  clientApi.get<HuaweiBookmark[]>('me/bookmarks/references/huawei/all');

export const fetchProviders = () => clientApi.get<ProviderClientDTO[]>('me/providers');

export type TitleProduct = {
  contentType: 'svod' | 'tvod' | 'vod';
  expiration: string;
  id: string;
  price: number;
  resolution: 'HD' | 'SD';
  title: string;
};

export const fetchProducts = (platformTitleId: string) =>
  clientApi.get<TitleProduct[]>(`products/title/${platformTitleId}`);

export const fetchFavoritesInsights = () =>
  profileAdminApi.get<FavoritesInsightsResponse>('favorites/insights');
